import { Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid2';

import SimpleCard from '../ui/SimpleCard';
import ShuffleIcon from '../../assets/images/shuffle.svg';
import { ReactComponent as ShareIcon } from '../../assets/images/share.svg';
import TokenSupplyStatus from '../tokens/TokenSupplyStatus';
import PlanByPurpose from '../tokens/PlanByPurpose';
import PossessionByPurpose from '../tokens/PossessionByPurpose';
import { useEffect, useState } from 'react';
import Web3j from '../../web3/Web3j';
import BigNumber from 'bignumber.js';
import { packBigNumbers } from '../../lib/Bignumbers';
import { StatusPossessionType } from '../../types/PurposeType';
import Disclaimer from '../footer/Disclaimer';
import { ticker } from '../../api/ticker';
import { arrSfl } from '../tokens/Addresses';
import { TOKEN_SFL } from '../../lib/name-space';

const ShuffleTabItem = () => {
  const [web3j, setWeb3j] = useState<Web3j | undefined>(undefined);
  const [info, setInfo] = useState<StatusPossessionType[] | null>(null);
  const [price, setPrice] = useState<string>('0');
  const isMobile = useMediaQuery('(max-width:900px)');

  useEffect(() => {
    if (web3j) {
      return;
    }
    const re = new Web3j();
    setWeb3j(re);

    return () => {};
  }, [web3j]);

  useEffect(() => {
    (async () => {
      const re = await ticker({ symbol: TOKEN_SFL });

      setPrice(packBigNumbers(re.data.latest_price, 6));
    })();
    return () => {};
  }, [web3j]);

  useEffect(() => {
    if (web3j) {
      (async () => {
        await fetchBalance();
      })();
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [web3j]);

  const sflCardList = [
    { title: 'Current Price', value: `${price} USD` },
    // {
    //   title: 'The Rate Of Change In Prices (24h)',
    //   value: '2.99%',
    //   color: 'blue',
    // },
    // { title: 'Holders', value: '60' },
    // { title: 'Transaction Value (24h)', value: '100,000 USD' },
  ];

  const fetchBalance = async () => {
    if (!web3j) return;

    const groupedItems: Record<string, any[]> = {};

    // 그룹화하여 배열 생성
    await Promise.all(
      arrSfl.map(async (item) => {
        const balance = await web3j.getTokenBalance(item.address, item.symbol);

        if (!groupedItems[item.title]) {
          groupedItems[item.title] = [];
        }

        groupedItems[item.title].push({ ...item, balance });
      })
    );

    const res: StatusPossessionType[] = arrSfl
      .map((originalItem) => {
        const group = groupedItems[originalItem.title];
        if (!group || group.length === 0) return null;
        delete groupedItems[originalItem.title]; // 이미 처리한 그룹은 제거

        if (group.length === 1) {
          const item = group[0];
          return {
            ...item,
            amount: packBigNumbers(item.amount, 0),
            remainingAmount: packBigNumbers(item.balance, 0),
            unlockUmount: packBigNumbers(BigNumber(item.amount).minus(item.balance), 0),
            length: group.length,
          };
        } else {
          const totalBalance = group.reduce((acc, cur) => acc.plus(cur.balance), BigNumber(0));
          return {
            address: group[0].address,
            // address2: group.length > 1 ? group[1].address : undefined,
            title: group[0].title,
            symbol: group[0].symbol,
            amount: packBigNumbers(group[0].amount, 0),
            remainingAmount: packBigNumbers(totalBalance, 0),
            unlockUmount: packBigNumbers(BigNumber(group[0].amount).minus(totalBalance), 0),
            length: group.length,
          };
        }
      })
      .filter(Boolean); // null 값 제거

    setInfo(res);
  };

  return (
    <Box sx={{ pb: '85px' }}>
      {/* SFL Simple Cards */}
      <Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <img src={ShuffleIcon} alt="shuffle symbol icon" />
            <Typography variant="h3">SFL</Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: { xs: '11px', md: '12px' },
                lineHeight: { xs: '18px', md: '34px' },
                letterSpacing: '-0.02em',
                color: '#000000',
              }}
            >
              View In Polygon Scan
            </Typography>
            <IconButton
              onClick={() => {
                const url = `https://polygonscan.com/token/0xbbe2b016271c22d3de3f961480af2941a0c4d067`;
                window.open(url, '_blank', 'noopener,noreferrer'); // 새 창에서 열기
              }}
            >
              <ShareIcon width={isMobile ? 12 : 15} height={isMobile ? 12 : 15} color={'#333333'} />
            </IconButton>
          </Box>
        </Box>
        <Grid
          container
          sx={{
            mt: '20px',
          }}
          spacing={'12px'}
        >
          {sflCardList.map((card) => (
            <Grid key={card.title} size={{ xs: 12, md: 6, lg: 3 }}>
              {/* <SimpleCard title={card.title} value={card.value} color={card?.color} /> */}
              <SimpleCard title={card.title} value={card.value} />
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Token Supply Status */}
      <TokenSupplyStatus type={TOKEN_SFL} />

      {/* Distribution and Retention Plan by Purpose */}
      <PlanByPurpose type="shuffle" />

      {/* Status of possession by purpose */}
      {info && <PossessionByPurpose type="shuffle" info={info} />}

      {/* DisClaimer */}
      <Disclaimer />
    </Box>
  );
};

export default ShuffleTabItem;
